export default __webpack_public_path__ + "static/media/PropertyDev_Shapes-01.f055c52a.png";